import { useCommercialOrderApi } from './useCommercialOrderApi';
import { useCommercialOrderGetters } from './useCommercialOrderGetters';
import { useCommercialOrderHelpers } from './useCommercialOrderHelpers';

import type { UseCommercialOrder } from './types';

export function useCommercialOrder(): UseCommercialOrder {
  return {
    ...useCommercialOrderApi(),
    ...useCommercialOrderGetters(),
    ...useCommercialOrderHelpers(),
  };
}
